import "./FieldError.scss";

const FieldError = (props) => {
  return <p className="error">{props.text ? props.text : props.children}</p>;
};

export default FieldError;